import { defineStore } from 'pinia'

interface TransferState {
  betAccounts: Record<string, string[]>
  creditRate: number
}
const STORE_NAME = 'TRANSFER_STORE'

export const useTransferStore = defineStore(STORE_NAME, {
  state: (): TransferState => ({
    betAccounts: {},
    creditRate: 100
  }),
  persist: false,
  actions: {
    setBetAccounts(betAccounts: Record<string, string[]>) {
      this.betAccounts = betAccounts
    },
    getBetAccounts(): Record<string, string[]> {
      return this.betAccounts
    },
    setCreditRate(creditRate: number) {
      if (!creditRate) {
        this.creditRate = 100
      }
      this.creditRate = creditRate
    },
    getCreditRate(): number {
      return this.creditRate
    }
  }
})
